// Module
var code = `<div class="row"> <a (click)="getPanel()" class="background-amadeus-grey5" [ngClass]="{'active': currentPanel === selectedPanelId }"> {{ 'office.panel.panel' + selectedPanelId | translate }} ({{ selectedPanelId }}) </a> </div> `;
// Exports
module.exports = code;